<template>
  <div class="cookie-preferences">
    <div class="cookie-preferences__content">
      <span class="cookie-preferences__text">
        To review or change your cookie consent preferences, use
      </span>
      <button
        id="hs_show_banner_button"
        type="button"
        class="cookie-preferences__button"
        @click="showHubSpotCookieBanner"
      >
        Cookie settings
      </button>
    </div>
  </div>
</template>

<script>
import { showHubSpotCookieBanner } from '@/helpers/hubspot'

export default {
  name: 'CookiePreferencesNotice',
  methods: {
    showHubSpotCookieBanner,
  },
}
</script>

<style lang="scss" scoped>
.cookie-preferences {
  width: 100%;
  background: var(--black);
  padding: 0 20px 30px;
  @include mobile {
    padding: 0 50px 30px;
  }
  &__content {
    width: 100%;
    max-width: 1120px;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    justify-content: center;
    column-gap: 5px;
    row-gap: 5px;
    text-align: center;
    @include mobile {
      justify-content: flex-start;
      text-align: left;
    }
  }
  &__text {
    color: var(--boulder);
    font-size: rem(12px);
    font-weight: 450;
    line-height: rem(16px);
  }
  &__button {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    color: var(--light-purple);
    font-family: inherit;
    font-size: rem(12px);
    font-weight: 450;
    line-height: rem(16px);
    text-decoration: underline;
  }
}
</style>
